export default __webpack_public_path__ + "static/media/youtube.88888157.png";